module.exports = __webpack_public_path__ + "static/template_list-4522bef081fe056213bf0191b805996b.png";